module.exports = __webpack_public_path__ + "img/1581299207.454be6d4.jpg";